import { render, staticRenderFns } from "./ExtensionAndProformaListDashboard.vue?vue&type=template&id=9391c86e&scoped=true&lang=pug&"
import script from "./ExtensionAndProformaListDashboard.vue?vue&type=script&lang=ts&"
export * from "./ExtensionAndProformaListDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./ExtensionAndProformaListDashboard.vue?vue&type=style&index=0&id=9391c86e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9391c86e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
